// extracted by mini-css-extract-plugin
module.exports = {"decor-card__container":"decor-card__container--f6285","decor-card__title":"decor-card__title--f6285","decor-card-container":"decor-card-container--f6285","cta":"cta--f6285"};